import { render } from "./ModalGridConfig.vue?vue&type=template&id=036cba99&scoped=true"
import script from "./ModalGridConfig.vue?vue&type=script&lang=js"
export * from "./ModalGridConfig.vue?vue&type=script&lang=js"

import "./ModalGridConfig.vue?vue&type=style&index=0&id=036cba99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036cba99"]])

export default __exports__